import React from 'react';

const LegalNotice: React.FC = () => {
  return (
    <div className="py-24 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 md:px-6">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-8">
          Mentions Légales
        </h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none">
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Informations sur l'entreprise</h2>
            <p>
              <strong>Raison sociale :</strong> GCM FRANCE<br />
              <strong>Forme juridique :</strong> SARL au capital de 1000 €<br />
              <strong>Siège social :</strong> 60 Rue Moslard, 92700 Colombes, France<br />
              <strong>SIRET :</strong> 909 025 512 00015<br />
              <strong>RCS :</strong> Nanterre 909 025 512<br />
              <strong>N° TVA Intracommunautaire :</strong> FR 21 909 025 512<br />
              <strong>Téléphone :</strong> 07 74 39 28 61<br />
              <strong>Email :</strong> gcmcouverture@gmail.com
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Directeur de la publication</h2>
            <p>
              <strong>Nom :</strong> KILINC BURCASLAN<br />
              <strong>Qualité :</strong> Gérant
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Hébergement du site</h2>
            <p>
              <strong>Raison sociale :</strong> HOSTINGER operations, UAB<br />
              <strong>Adresse :</strong> Švitrigailos str. 34, Vilnius 03230 Lithuania<br />
              <strong>Téléphone :</strong> +37064503378<br />
              <strong>Email :</strong> domains@hostinger.com<br />
            </p>
          </section>
          
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-semibold mb-4">Propriété intellectuelle</h2>
            <p>
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
            <p>
              La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
